import { SendFormData } from "../../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {
    const verifyButtonList = document.querySelectorAll('.wcl-verify-button');

    if (verifyButtonList.length) {
        verifyButtonList.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();

                const form = btn.closest('.wcl-modal-form');
                const formWrapper = form.closest('.wcl-modal-inner');

                const userId = form.dataset.userId;
                const userCodeType = 'verify';

                // Profile pop-up
                const profilePopUp = document.getElementById('wcl-profile-popup');

                //Confirm Code Modal
                const modalConfirmCode = document.getElementById('wcl-modal-confirm-code-popup');
                const confirmCodeForm = modalConfirmCode.querySelector('.wcl-modal-confirm-code');
                const confirmCodeUserEmail = document.getElementById('wcl-confirm-code-email');

                const confirmTextLabel = modalConfirmCode.querySelector('.wcl-js-confirm-code-label');
                const confirmTextTitle = modalConfirmCode.querySelector('.wcl-js-confirm-code-title');
                const confirmTextButton = modalConfirmCode.querySelector('.wcl-js-confirm');
                const confirmLaterButton = modalConfirmCode.querySelector('#wcl-js-confirm-later-code');
                const confirmLogoutButton = modalConfirmCode.querySelector('#wcl-logout-button');

                formWrapper.classList.add('loading');

                let formData = new FormData();

                formData.append('user_id', userId);
                formData.append('code_type', userCodeType);

                SendFormData('resending_code', formData).then(function (res) {
                    formWrapper.classList.remove('loading');

                    let response = JSON.parse(res);

                    if (response.success == '1') {
                        profilePopUp.classList.remove('active');
                        modalConfirmCode.classList.add('active');

                        // Get user_id and code_type from the response
                        const userId = response.user_id;
                        const userEmail = response.user_email;
                        const codeType = 'verify';

                        // Add data attributes to confirm code form
                        confirmCodeForm.setAttribute('data-user-id', userId);
                        confirmCodeForm.setAttribute('data-code-type', codeType);
                        confirmCodeUserEmail.textContent = userEmail;

                        //Change text and blocks for confirm code modal
                        confirmTextLabel.textContent = '';
                        confirmTextTitle.textContent = multilanguage_object['Verify your email address'];
                        confirmTextButton.value = multilanguage_object['Confirm'];

                    } else {
                        throw response.message;
                    }

                }).catch(function (err) {
                    // Error
                    formWrapper.classList.remove('loading');

                    messageBlock.classList.add('show', 'error');
                    message.innerHTML = err;
                });

            });
        });
    }
});